import { render, staticRenderFns } from "./UnihallQuotaPriceSelectbox.vue?vue&type=template&id=74d2608e"
import script from "./UnihallQuotaPriceSelectbox.vue?vue&type=script&lang=js"
export * from "./UnihallQuotaPriceSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports